import { TalonOneDiscount } from "src/types/TalonOne";
import { safeJsonParse } from "./helper/json-parser";
import { Cart } from "src/types/ctgraphql.d";
import { DiscountCodeState } from "src/types/graphql.d";

export function getTalonOneDiscounts(
  customFields: Cart["custom"]
): TalonOneDiscount[] {
  if (!customFields || !customFields?.customFieldsRaw) {
    return [];
  }

  return (
    safeJsonParse<TalonOneDiscount[]>(
      (customFields.customFieldsRaw.find(
        ({ name }) => name === "talonone_discount_codes"
      )?.value as string) || "[]"
    ) || []
  );
}

export function getTalonOneDiscountAmount(cart: Cart | null): string {
  if (!cart || !cart.custom || !cart.custom.customFieldsRaw) {
    return "";
  }

  const talonOneDiscountValue = getTalonOneDiscounts(cart.custom)
    ?.filter((discount) => discount.state === DiscountCodeState.CouponAccepted)
    ?.at(0)?.lineItemDiscountsTotal;

  const talonOneDiscountFormatted = talonOneDiscountValue
    ? Number(talonOneDiscountValue / Math.pow(10, 2)).toString()
    : "";

  return talonOneDiscountFormatted;
}
